module.exports = __webpack_public_path__ + "img/33-s.c07e50cd.png";